import { render, staticRenderFns } from "./TraxSettingBackgroundCrud.vue?vue&type=template&id=cdfc64fe"
import script from "./TraxSettingBackgroundCrud.vue?vue&type=script&lang=js"
export * from "./TraxSettingBackgroundCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports